import { lazy } from 'react';
import { useSurrenderRoot } from 'src/pages/reporting/surrender/use-surrender-root';

const Page = lazy(() => import('./page'));

export const CreateSurrenderRequest = () => {
  const surrenderRoot = useSurrenderRoot();
  return <Page surrenderRoot={surrenderRoot} />;
};
